import { Config } from '../../src/types';

export default {
  store: {
    state: {
      features: {
        ageMatching: false,
      },
      copy: {
        name: 'YAP',
        tooltips: {
          salaryInput: '',
          annualMonthly: '',
        },
      },
      assumptions: {
        contributionRates: [0.03, 0.04, 0.05],
        employerMatch: {
          101: {
            employee: [0.03, 0.04, 0.05],
            employer: [0.06, 0.07, 0.07],
          },
        },
      },
    },
  },

  hooks: {
  //   beforeInitialise(vm, store, router) {},
  //   afterInitialise(vm, store, router) {},
  },
} as Config;
